/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Flatten {
  /**
   * A shallow flatten, so if an item has an array that is placed in to the list
   * @public
   * @function f1.flatten
   * @param depth the depth to flatten, default should be 1
   * @param arr the array of arrays to flatten
   * @example
   *
   * ```ts
   * f1.flatten(1, [1, 2, [3, 4], 5]) => [1, 2, 3, 4, 5]
   * ```
   */
  <T>(depth: 4, arr: T[][][][][]): T[];
  <T>(depth: 4): (arr: T[][][][][]) => T[];

  <T>(depth: 3, arr: T[][][][]): T[];
  <T>(depth: 3): (arr: T[][][][]) => T[];

  <T>(depth: 2, arr: T[][][]): T[];
  <T>(depth: 2): (arr: T[][][]) => T[];

  <T>(depth: 1, arr: T[][]): T[];
  <T>(depth: 1): (arr: T[][]) => T[];

  <T>(depth: number, arr: T[]): T[];
  <T>(depth: number): (arr: T[]) => T[];
}

/**
 * @see Flatten
 */
export default <T>(depth: number, arr: T[]): T[] => {
  return arr.flat(depth) as T[];
};
